import { onUnmounted, ref } from 'vue';

const isOpen = ref(false);
const paymentAmount = ref(0);
const availableAmount = ref(0);
const currency = ref('');
let resolveConfirmation: ((shouldContinue: boolean) => void) | null = null;

const finishConfirmation = (shouldContinue: boolean) => {
  const resolve = resolveConfirmation;
  resolveConfirmation = null;
  isOpen.value = false;
  resolve?.(shouldContinue);
};

export function useInsufficientFundsConfirmation() {
  const confirmInsufficientFunds = (nextPaymentAmount: number, nextAvailableAmount: number, nextCurrency: string) => {
    finishConfirmation(false);

    paymentAmount.value = nextPaymentAmount;
    availableAmount.value = nextAvailableAmount;
    currency.value = nextCurrency;
    isOpen.value = true;

    return new Promise<boolean>((resolve) => {
      resolveConfirmation = resolve;
    });
  };

  const updateOpenState = (value: boolean) => {
    if (value) {
      isOpen.value = true;
      return;
    }

    finishConfirmation(false);
  };

  return {
    isOpen,
    paymentAmount,
    availableAmount,
    currency,
    confirmInsufficientFunds,
    continueInsufficientFunds: () => finishConfirmation(true),
    editInsufficientFunds: () => finishConfirmation(false),
    updateOpenState,
  };
}

export function registerInsufficientFundsConfirmationCleanup() {
  onUnmounted(() => finishConfirmation(false));
}
